import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import IntersectionObserverReal from '@researchgate/react-intersection-observer';

require('intersection-observer');

const IntersectionObserverMock = ({ children }) => (
  <Fragment>{children}</Fragment>
); // eslint-disable-line

IntersectionObserverMock.propTypes = {
  children: PropTypes.node.isRequired,
};

export default typeof IntersectionObserver === 'undefined'
  ? IntersectionObserverMock
  : IntersectionObserverReal;
